import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ShortcutHelpModal from "./ShortcutHelpModal";
import { useDarkMode } from "./context/darkModeContext";

const COMMON_SHORTCUTS = [
  { keys: "alt+d", route: "/", description: "Command Center" },
  { keys: "alt+e", route: "/insight", description: "Insight" },
  { keys: "alt+c", route: "/catalog", description: "Catalog" },
  {
    keys: "alt+shift+p",
    route: "/purchase-order",
    description: "Purchase Order",
  },
  {
    keys: "alt+p",
    route: "/product",
    description: "Product List",
  },
  { keys: "alt+f", route: "/forecast", description: "Forecast" },
  {
    keys: "alt+a",
    route: "/redefined-copilot",
    description: "Redefined Copilot",
  },
  { keys: "alt+h", route: "/help", description: "Show All Shortcuts" },
  {
    keys: "alt+shift+d",
    action: "toggle-theme",
    description: "Toggle Dark Theme",
  },
  {
    keys: "alt+o",
    route: "/order-management",
    description: "Order Management",
  },
  {
    keys: "alt+n",
    route: "/alert-and-notification",
    description: "Alert & Notification",
  },
];

const ADMIN_ONLY_SHORTCUTS = [
  { keys: "alt+r", route: "/roles", description: "Roles" },
  { keys: "alt+u", route: "/users", description: "Users" },
  { keys: "alt+t", route: "/transaction", description: "Transactions" },
];

const CLIENT_ONLY_SHORTCUTS = [];

const ADMIN_SHORTCUTS = [...COMMON_SHORTCUTS, ...ADMIN_ONLY_SHORTCUTS];
const CLIENT_SHORTCUTS = [...COMMON_SHORTCUTS, ...CLIENT_ONLY_SHORTCUTS];
const KeyboardShortcuts = () => {
  const navigate = useNavigate();
  const [SHORTCUTS, setShortcuts] = useState(CLIENT_SHORTCUTS);
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const rolesRaw = localStorage.getItem("roles");
  const roles =
    rolesRaw && rolesRaw !== "undefined" ? JSON.parse(rolesRaw) || [] : [];
  const { toggleDarkMode } = useDarkMode();

  useEffect(() => {
    // Set shortcuts based on user roles
    if (roles.find((r) => r.name === "Admin")) {
      setShortcuts(ADMIN_SHORTCUTS);
    } else {
      setShortcuts(CLIENT_SHORTCUTS);
    }
  }, [roles]);
  useEffect(() => {
    // Function to handle keyboard events
    const handleKeyDown = (event) => {
      // Skip if user is typing in an input field
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA" ||
        event.target.isContentEditable
      ) {
        return;
      }

      // Convert key combination to string format (e.g., "alt+d")
      const keyCombo = [];
      if (event.altKey) keyCombo.push("alt");
      if (event.ctrlKey) keyCombo.push("ctrl");
      if (event.shiftKey) keyCombo.push("shift");
      if (
        event.key !== "Alt" &&
        event.key !== "Control" &&
        event.key !== "Shift"
      ) {
        keyCombo.push(event.key.toLowerCase());
      }

      const keyString = keyCombo.join("+");

      // Find matching shortcut
      const shortcut = SHORTCUTS.find((s) => s.keys === keyString);

      if (shortcut) {
        event.preventDefault();
        if (shortcut.route === "/help") {
          showShortcutsHelp();
          return;
        }
        if (shortcut.action === "toggle-theme") {
          toggleDarkMode();
          return;
        }
        navigate(shortcut.route);
      }
    };

    // Add event listener
    window.addEventListener("keydown", handleKeyDown);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  // Function to display all available shortcuts
  const showShortcutsHelp = () => {
    setHelpModalOpen(true);
  };

  return (
    <>
      <ShortcutHelpModal
        SHORTCUT_CATEGORIES={[
          {
            name: "Navigation",
            shortcuts: SHORTCUTS.filter(
              (x) => x.keys !== "alt+h" && x.keys !== "alt+shift+d",
            ).map((x) => x.keys),
          },
          {
            name: "Preferences",
            shortcuts: ["alt+shift+d"],
          },
          {
            name: "Help",
            shortcuts: ["alt+h"],
          },
        ]}
        SHORTCUTS={SHORTCUTS}
        open={helpModalOpen}
        onClose={() => setHelpModalOpen(false)}
      />
    </>
  );
};

export default KeyboardShortcuts;
